import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'

// AI 回复 markdown 渲染器——模型输出 markdown 语法,纯文本显示=一墙管道符(9/16 实证之耻)
// 样式内联于组件映射(tailwind),表格/列表/标题/粗体/行内码全落地
export default function Md({ text }: { text: string }) {
  return (
    <div className="text-sm leading-7 text-gray-700">
      <ReactMarkdown remarkPlugins={[remarkGfm]} components={{
        table: (p: any) => <table className="my-2 w-full border-collapse text-xs">{p.children}</table>,
        th: (p: any) => <th className="border-b border-gray-200 bg-gray-50 px-2 py-1.5 text-left font-medium text-gray-500">{p.children}</th>,
        td: (p: any) => <td className="border-b border-gray-100 px-2 py-1.5 align-top">{p.children}</td>,
        ul: (p: any) => <ul className="my-1 list-disc pl-5">{p.children}</ul>,
        ol: (p: any) => <ol className="my-1 list-decimal pl-5">{p.children}</ol>,
        h1: (p: any) => <h4 className="mt-2 mb-1 font-semibold text-gray-900">{p.children}</h4>,
        h2: (p: any) => <h4 className="mt-2 mb-1 font-semibold text-gray-900">{p.children}</h4>,
        h3: (p: any) => <h4 className="mt-2 mb-1 font-semibold text-gray-900">{p.children}</h4>,
        code: (p: any) => <code className="rounded bg-gray-100 px-1 py-0.5 text-[12px] text-rose-600">{p.children}</code>,
        strong: (p: any) => <strong className="font-semibold text-gray-900">{p.children}</strong>,
        p: (p: any) => <p className="my-1">{p.children}</p>,
      }}>{text}</ReactMarkdown>
    </div>
  )
}
